import React from "react";

const AccessDeniedPage = ({ onLogout }) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-red-500 mb-4">Access Denied</h1>
        <p className="text-lg text-gray-700 mb-6">
          You do not have permission to access this page.
        </p>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
